module.exports = __webpack_public_path__ + "img/footer_qccode.3310aa57.png";